import flatpickr from '../../_scripts/plugins/flatpickr/flatpickr.min';
import { Russian } from '../../_scripts/plugins/flatpickr/l10n/ru';
import FilterSearch from '../../_partials/filter-search/filter-search';

export default class SearchPage {

  constructor(overlay) {
    this.searchPageTimeLine = document.querySelector('.search-page__timeline');
    this.selectDate = document.querySelector('.select-date');
    this.filterSearch = document.querySelector('.filter-search');
    this.searchPageForm = document.querySelector('.search-page__form');
    this.searchFieldInput = this.searchPageForm.querySelector('.search-field__input');
    this.searchTitleSpan = this.searchPageForm.querySelector('.search-page__title-search');
    this.timeline = document.querySelector('.timeline');
    this.searchPageSelected;
    this.timelineInputAll;
    this.inputFocus;
    this.overlay = overlay;
  }

  _removeClassActive() {
    [...document.querySelectorAll('.timeline__item')].map(item => {
      item.classList.remove('timeline__item--active');
    });

    [...this.selectDate.options].map(item => {
      item.removeAttribute('selected');
    });
  }

  _addClassActive(target) {
    this._removeClassActive();
    target.closest('.timeline__item').classList.add('timeline__item--active');
  }

  _datePicker(input, inputToValue) {
    [...input].map(item => {
      flatpickr(item, {
        'locale': Russian,
        dateFormat: 'd.m.Y',
        disableMobile: true,
        static: true,
        minDate: inputToValue,
        prevArrow: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.5835 2.50011L4.54304 8.63128" stroke="#918184" stroke-width="2"/> <path d="M10.5835 14.3446L4.54304 8.21345" stroke="#918184" stroke-width="2"/></svg>',
        nextArrow: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5.41651 2.50011L11.457 8.63128" stroke="#918184" stroke-width="2"/> <path d="M5.41651 14.3446L11.457 8.21345" stroke="#918184" stroke-width="2"/></svg>'
      });
    });
  }

  _createSelectDate() {
    const selectDateOptions = this.selectDate.options;

    const createTimelineList = document.createElement('ul');
    createTimelineList.setAttribute('class', 'timeline__list');

    const buttonMoreFilters = `
        <div class="button search-page__button-filters">
          <svg viewBox="0 0 24 24" class="angle-svg angle-svg--top-section">
            <use xlink:href="#angle"></use>
          </svg><span class="search-page__selected">За все время</span>
        </div>
      `;

    const selectTimeLineMobile = `
        <div class="close close--select">
        <div class="close__line"></div>
        </div><span class="search-page__mobile-span">Материалы за ...</span>
      `;

    const createTimeLineMobile = document.createElement('div');
    createTimeLineMobile.setAttribute('class', 'search-page__mobile search-page__mobile--hide');
    createTimeLineMobile.innerHTML = selectTimeLineMobile;

    this.searchPageTimeLine.insertAdjacentHTML('afterbegin', buttonMoreFilters);
    createTimeLineMobile.appendChild(createTimelineList);
    this.searchPageTimeLine.appendChild(createTimeLineMobile);
    this.searchPageSelected = this.searchPageForm.querySelector('.search-page__selected');

    for (let i = 0; i < selectDateOptions.length; i++) {
      const createTimelineItem = document.createElement('li');
      createTimelineItem.setAttribute('class', 'timeline__item');

      const createSpan = document.createElement('span');
      createSpan.setAttribute('class', 'timeline__span-checkbox');
      createTimelineItem.appendChild(createSpan);

      createTimelineItem.classList.add('timeline__item--button');
      createTimelineItem.insertAdjacentHTML('beforeend', selectDateOptions[i].innerHTML);

      selectDateOptions[i].selected
        && (
          createTimelineItem.classList.add('timeline__item--active'),
          this.searchPageSelected.innerHTML = createTimelineItem.childNodes[1].nodeValue
        );

      if (i === 3) {
        const createInputDateWrapper = document.createElement('div');
        createInputDateWrapper.setAttribute('class', 'search-page__input-mobile');
        this._createInputDate(createInputDateWrapper, createTimelineItem, selectDateOptions[i]);
        this.searchPageTimeLine.appendChild(createInputDateWrapper);

        selectDateOptions[i].selected
          && createInputDateWrapper.classList.add('search-page__input-mobile--visible');

        createTimelineItem.addEventListener('click', e => {
          this.searchPageSelected.innerHTML = e.target.childNodes[1].nodeValue;
          this._addClassActive(createTimelineItem);
          selectDateOptions[i].selected = createTimelineItem;
          selectDateOptions[i].setAttribute('selected', '');
          this._closeMobileTimeLine();

          createInputDateWrapper.classList.add('search-page__input-mobile--visible');
          setTimeout(() => {
            this.searchPageForm.querySelector('.timeline__input--from').focus();
          }, 150);
        });

        this._timeLineResize(createInputDateWrapper, createTimelineItem, selectDateOptions[i]);
      }
      else {
        createTimelineItem.addEventListener('click', e => {
          this.searchPageSelected.innerHTML = e.target.childNodes[1].nodeValue;
          this._addClassActive(createTimelineItem);
          selectDateOptions[i].selected = createTimelineItem;
          selectDateOptions[i].setAttribute('selected', '');
          this.searchPageForm.submit();
          this._closeMobileTimeLine();

          const inputMobile = this.searchPageForm.querySelector('.search-page__input-mobile');
          inputMobile.classList.contains('search-page__input-mobile--visible')
            && inputMobile.classList.remove('search-page__input-mobile--visible');
        });
      }
      createTimelineList.appendChild(createTimelineItem);
    }

    this.timelineInputAll = document.querySelectorAll('.timeline__input');
    this._datePicker(this.timelineInputAll);
  }

  _timeLineResize(inputWrapper, item, option) {
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 768) {
        option.selected
          && (
            item.classList.add('timeline__item--active'),
            this.searchPageSelected.innerHTML = item.childNodes[1].nodeValue,
            inputWrapper.classList.add('search-page__input-mobile--visible')
          );
      }
    });
  }

  _createInputDate(wrapperInput, item, option) {
    const createInputFrom = document.createElement('input');
    createInputFrom.setAttribute('type', 'text');
    createInputFrom.setAttribute('class', 'timeline__input timeline__input--from flatpickr-input');
    createInputFrom.setAttribute('readonly', 'readonly');
    createInputFrom.setAttribute('placeholder', 'от');

    const createInputTo = document.createElement('input');
    createInputTo.setAttribute('type', 'text');
    createInputTo.setAttribute('class', 'timeline__input timeline__input--to flatpickr-input');
    createInputTo.setAttribute('readonly', 'readonly');
    createInputTo.setAttribute('placeholder', 'до');

    wrapperInput.appendChild(createInputFrom);
    wrapperInput.appendChild(createInputTo);

    this._handleInputTime(wrapperInput, createInputFrom, item, option);
    this._handleInputTime(wrapperInput, createInputTo, item, option);
  }

  _handleInputTime(wrapperInput, input, item, option) {
    if (window.innerWidth > 768) {
      input.addEventListener('focus', () => {
        wrapperInput.classList.add('search-page__input-mobile--visible');
        this._addClassActive(item);
        option.selected = item;
        option.setAttribute('selected', '');
      });
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        input.addEventListener('focus', () => {
          wrapperInput.classList.add('search-page__input-mobile--visible');
          this._addClassActive(item);
          option.selected = item;
          option.setAttribute('selected', '');
        });
      }
    });
    input.addEventListener('change', e => {
      const target = e.target.closest('.search-page__input-mobile');
      const timeFromTo = [];
      const inputFrom = target.querySelector('.timeline__input--from');
      const inputTo = target.querySelector('.timeline__input--to');
      option.selected = item;

      e.target.classList.contains('timeline__input--from') && inputTo.value === ''
        ? e.preventDefault()
        : e.target.classList.contains('timeline__input--to') && inputFrom.value === ''
          ? e.preventDefault()
          : (
            timeFromTo[timeFromTo.length] = inputFrom.value,
            timeFromTo[timeFromTo.length] = inputTo.value,
            option.setAttribute('value', timeFromTo),
            this.searchPageForm.submit()
          );
    });
  }

  _setTitleSearch() {
    this.searchTitleSpan.innerHTML = this.searchFieldInput.value;
  }

  _closeTimeLine() {
    this.carouselTime.classList.remove('carousel-time--visible');
    this.topGlobalDateButton.classList.remove('top-section__date-button--active');
    this.overlay.classList.remove('overlay--visible');

    document.body.classList.contains('scroll-lock')
      && document.body.classList.remove('scroll-lock');
  };

  _closeMobileTimeLine() {
    document.querySelector('.search-page__mobile').classList.add('search-page__mobile--hide');
    this.overlay.classList.remove('overlay--visible');

    document.body.classList.contains('scroll-lock')
      && document.body.classList.remove('scroll-lock');
  }

  init() {

    this._createSelectDate();

    this.filterSearch
      && new FilterSearch(this.searchPageForm);

    if (this.searchPageForm) {
      this.searchPageForm.addEventListener('submit', e => {
        e.preventDefault();
        this.searchPageForm.submit();
      });
    }

    if (document.querySelector('.search-page__button-filters')) {
      document.querySelector('.search-page__button-filters').addEventListener('click', () => {
        document.querySelector('.search-page__mobile').classList.remove('search-page__mobile--hide');
        this.overlay.classList.add('overlay--visible');

        window.innerWidth <= 1024
          && document.body.classList.add('scroll-lock');
      });

      this.searchPageForm.querySelector('.close').addEventListener('click', () => {
        this._closeMobileTimeLine();
      });

      this.overlay.addEventListener('click', () => {
        this._closeMobileTimeLine();
      });
    }
  }
}